import React,{useEffect,useRef,useState} from 'react';
import {onAuthStateChanged} from 'firebase/auth';
import {auth} from '../../firebaseConfig';
import {refreshKnownOrganizationPush,subscribeForegroundPush} from '../../services/announcementPushService';

export default function ForegroundNotificationBanner(){
  const [uid,setUid]=useState(''),[notice,setNotice]=useState(null);
  const seen=useRef(new Set());
  useEffect(()=>onAuthStateChanged(auth,user=>{setUid(user?.uid || '');setNotice(null);seen.current.clear();}),[]);
  useEffect(()=>{
    if(!uid)return undefined;
    let lastRefresh=0,active=true;
    const refresh=()=>{if(document.visibilityState==='hidden' || Date.now()-lastRefresh<300000)return;lastRefresh=Date.now();void refreshKnownOrganizationPush().catch(()=>{});};
    refresh();document.addEventListener('visibilitychange',refresh);
    const off=subscribeForegroundPush(payload=>{
      if(!active || auth.currentUser?.uid!==uid || payload.data?.recipientUid!==uid || !payload.data?.orgId)return;
      let url;try{url=new URL(payload.data.url);if(url.origin!==window.location.origin || !['https:','http:'].includes(url.protocol))return;}catch{return;}
      const id=payload.messageId || [payload.data.orgId,payload.data.announcementId,payload.data.messageId,payload.notification?.title,payload.notification?.body].join(':');
      if(seen.current.has(id))return;seen.current.add(id);if(seen.current.size>30)seen.current.delete(seen.current.values().next().value);
      setNotice({uid,url:url.href,title:payload.notification?.title || 'New update',body:payload.notification?.body || 'Open to read the update.'});
    });
    return ()=>{active=false;off();document.removeEventListener('visibilitychange',refresh);};
  },[uid]);
  if(!notice || notice.uid!==uid || auth.currentUser?.uid!==uid)return null;
  return <aside role="status" aria-label="New notification" className="fixed left-4 right-4 top-4 z-[100] mx-auto flex max-w-lg gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-slate-950 shadow-xl">
    <a href={notice.url} className="min-w-0 flex-1 no-underline"><strong className="block">{notice.title}</strong><span className="line-clamp-2 text-sm">{notice.body}</span></a>
    <button type="button" aria-label="Dismiss notification" className="min-h-11 min-w-11" onClick={()=>setNotice(null)}>×</button>
  </aside>;
}
